import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { TONES, PERIOD_OPTIONS } from 'api/administrador/monitoring/aiGrading';

export function StatusPill({ label, tone = 'gray', size = '11px' }) {
  const t = TONES[tone] || TONES.gray;
  return (
    <Box
      as="span"
      display="inline-flex"
      px={2.5}
      py={1}
      borderRadius="999px"
      fontSize={size}
      fontWeight="600"
      bg={t.bg}
      color={t.color}
      border="1px solid"
      borderColor={t.border}
      whiteSpace="nowrap"
    >
      {label}
    </Box>
  );
}

/** Selector Hoy / 7 días / 30 días (mismo estilo que Clases grabadas). */
export function PeriodPicker({ value, onChange, label = true }) {
  return (
    <Flex align="center" gap={3}>
      {label && (
        <Text fontSize="11px" fontWeight="700" letterSpacing=".05em" textTransform="uppercase" color="gray.500">
          Periodo
        </Text>
      )}
      <Flex role="group" aria-label="Periodo" bg="white" border="1px solid" borderColor="gray.200" borderRadius="10px" p="3px" gap="2px">
        {PERIOD_OPTIONS.map((o) => {
          const active = value === o.value;
          return (
            <Box
              key={o.value}
              as="button"
              type="button"
              onClick={() => onChange(o.value)}
              px={3}
              py="6px"
              borderRadius="8px"
              fontSize="13px"
              fontWeight={active ? '600' : '500'}
              bg={active ? '#6D48E5' : 'transparent'}
              color={active ? 'white' : 'gray.600'}
              _hover={active ? {} : { bg: 'gray.100' }}
              transition="background .15s"
              aria-pressed={active}
            >
              {o.label}
            </Box>
          );
        })}
      </Flex>
    </Flex>
  );
}

/** Filtros tipo pastilla (Todas · 412, Por publicar · 58…). */
export function ChipGroup({ options, value, onChange, ariaLabel }) {
  return (
    <Flex role="group" aria-label={ariaLabel} gap={2} wrap="wrap">
      {options.map((o) => {
        const active = value === o.value;
        return (
          <Box
            key={o.value}
            as="button"
            type="button"
            onClick={() => onChange(o.value)}
            aria-pressed={active}
            h="32px"
            px={3}
            borderRadius="999px"
            border="1px solid"
            borderColor={active ? '#C7D2FE' : 'gray.200'}
            bg={active ? '#EEF0FE' : 'white'}
            color={active ? '#3730A3' : 'gray.600'}
            fontSize="13px"
            fontWeight="500"
            _hover={active ? {} : { bg: 'gray.50' }}
          >
            {o.label}
          </Box>
        );
      })}
    </Flex>
  );
}

export function KpiCard({ label, value, foot, color, loading }) {
  return (
    <Box bg="white" border="1px solid" borderColor="gray.200" borderRadius="14px" p={4}>
      <Flex justify="space-between" align="center">
        <Text fontSize="11px" color="gray.500" fontWeight="500" letterSpacing=".02em" textTransform="uppercase">
          {label}
        </Text>
        <Box w="8px" h="8px" borderRadius="999px" bg={color} />
      </Flex>
      <Text fontSize="28px" fontWeight="700" color="gray.900" letterSpacing="-.02em" lineHeight="1" mt={2}>
        {loading ? '…' : value}
      </Text>
      {foot && (
        <Text fontSize="12px" color="gray.500" mt={1}>
          {foot}
        </Text>
      )}
    </Box>
  );
}

/** Encabezado corto de una pestaña: qué es y para qué sirve. */
export function TabIntro({ title, children }) {
  return (
    <Box px={5} pt={5} pb={1}>
      <Text fontSize="16px" fontWeight="700" color="gray.900">{title}</Text>
      <Text fontSize="14px" color="gray.600" mt={1} maxW="860px" lineHeight="1.5">{children}</Text>
    </Box>
  );
}
